const FileTypeFormatting = {
  stat: 'STAT #',
};
export default FileTypeFormatting;
